import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/swastishanti-staging/frontend-nextjs/components/CalendarGrid.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroAnimation"] */ "/var/www/swastishanti-staging/frontend-nextjs/components/HeroAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/swastishanti-staging/frontend-nextjs/components/MainLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/swastishanti-staging/frontend-nextjs/components/PanchangaSidebar.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/RasiPhalSection.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/swastishanti-staging/frontend-nextjs/components/ServicesWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/WhyChooseSection.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
